import { memo } from "react";
import { cn } from "utils";

const TokenPriceDisplay = ({
  integerPart,
  leftDigits,
  zeroCount,
  zeroCountClass,
  className,
  hideUnitSymbol,
}: {
  integerPart: string;
  leftDigits?: string | null;
  zeroCount?: number;
  zeroCountClass?: string;
  className?: string;
  hideUnitSymbol?: boolean;
}) => {
  if (!integerPart) {
    return (
      <span
        className={cn("headline_regular_l text-content_primary", className)}
      >
        --
      </span>
    );
  }

  return (
    <span className={cn("headline_regular_l text-content_primary", className)}>
      {!hideUnitSymbol && "$"}
      {integerPart}
      {leftDigits ? (
        zeroCount ? (
          <>
            .0
            <span
              className={cn(
                "text-content_primary body_medium_l",
                zeroCountClass,
              )}
              style={{ position: "relative", bottom: "-2px" }}
            >
              {zeroCount}
            </span>
            {leftDigits}
          </>
        ) : (
          `.${leftDigits}`
        )
      ) : (
        ""
      )}
    </span>
  );
};

export default memo(TokenPriceDisplay);
